import createElement from "./createElement";

/**
 * Meant to be called after the initial window.loading() or showLoading() call
 */
function setLoadingMessage(message, container = null) {
	if (!container) {
		container = document.querySelector('body > .loading');
	}

	let messageContainer = container.querySelector('.loading-message');

	if (!messageContainer) {
		// Create if missing
		messageContainer = createElement('<div class="alert alert-light loading-message"></div>');
		container.appendChild(messageContainer);
	}

	messageContainer.innerHTML = message;
	messageContainer.classList.remove('d-none');
}

function clearLoadingMessage(container = null) {
	if (!container) {
		container = document.querySelector('body > .loading');
	}

	let messageContainer = container.querySelector('.loading-message');

	if (!messageContainer) {
		// Do nothing
		return;
	}

	messageContainer.remove();
}

/**
 * This functions perform the same function as the
 * global 'loading' & 'stop loading' with the addition
 * of a target container
 */

function showLoading(container = null) {
	if (!container) {
		window.loading();
		return;
	}

	container.classList.add('loadable');

	container.classList.add('load');
	container.appendChild(createElement('<div class="lds-ring"><div></div><div></div><div></div><div></div></div>'));
}

function hideLoading(container = null) {
	if (!container) {
		window.stopLoading();
		return;
	}
	container.classList.remove('load');

	clearLoadingMessage(container);

	const loadingRing = container.querySelector('.lds-ring');
	if (loadingRing) {
		loadingRing.parentElement.removeChild(loadingRing);
	}
}

export {
	showLoading,
	hideLoading,
	setLoadingMessage
}
